import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { resetPasswordConfirm } from '../../actions';
import { AuthPage } from '../../components';
import Button from '../../components/widgets/Button';
import { getAuthState } from '../../selectors';

class ForgotPasswordConfirmPage extends React.Component {
  static propTypes = {
    resetPasswordConfirm: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    authState: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      error: null,
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({error: nextProps.authState.error});
  }

  handleSubmit = (e) => {
    e.preventDefault();
    const newPassword = this.newPasswordInput.value;
    const newPassword2 = this.newPassword2Input.value;

    if (newPassword !== newPassword2) {
      this.setState({error: 'Password mismatch'});

      return false;
    }
    const {uid, token} = this.props.match.params;

    this.props.resetPasswordConfirm(uid, token, newPassword);
  }

  render() {
    return (
      <AuthPage heading="Password Reset">
        <form onSubmit={this.handleSubmit} className="form">
          <input id="new_password"
                 name="new_password"
                 required="required"
                 ref={(elem) => this.newPasswordInput = elem}
                 placeholder="New Password"
                 type="password"
                 disabled={this.props.authState.isLoading}/>
          <input id="new_password_r"
                 name="new_password_r"
                 required="required"
                 ref={(elem) => this.newPassword2Input = elem}
                 placeholder="New Password (again)"
                 type="password"
                 disabled={this.props.authState.isLoading}/>
          <div className="error-message">
            {this.state.error}
          </div>
          <div className="success-message">
            {this.state.error === false
              ? 'Password successfully reset, you can now log in with the new password.'
              : null}
          </div>
          <div className="actions">
            <Button submit onClick={this.handleSubmit} primary isDisabled={this.props.authState.isLoading}>
              { this.props.authState.isLoading ?
                  <i className="fa fa-refresh fa-spin" style={{color: 'white'}}></i>
                :
               "Change"
            }</Button>
          </div>
        </form>
      </AuthPage>
    );
  }
}

export default connect((state) => ({
    authState: getAuthState(state),
  }), {
    resetPasswordConfirm,
  },
)(ForgotPasswordConfirmPage);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/containers/PasswordResetConfirmPage/index.js